import styled from 'styled-components'
import check from './check.svg'

export const FieldNo = styled.div<{ checked?: boolean }>`
  display: inline-block;
  margin-right: 12px;
  width: 30px;
  height: 30px;
  background: #FC9426;
  border-radius: 50%;
  color: white;
  position: relative;

  font-family: Nunito;
  font-size: 16px;
  line-height: 30px;
  font-weight: 900;
  text-align: center;

  ${({ checked }) => checked && `
    color: transparent;
    background: #3DD7B1;
    ::before {
      content: "";
      position: absolute;
      top: 10px;
      left: 7px;
      width: 16px;
      height: 12px;
      background: url(${check});
    }
  `}
`



// WEBPACK FOOTER //
// ./src/atoms/FieldNo/index.tsx